export default "__VITE_ASSET__dmy_WsM0__"